/**
 * this function define if we’re in a popup or not
 * we have this case in only embedded features
 * @returns boolean
 */

export const isEmbedded = () => {
    return window.self !== window.top;
};
